import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { AppDownloadBanner } from '@gumtree/ui-library';
import { GrowthBookFeature, ExperimentVariant } from '@gumtree/shared/src/model/experiment';
import ErrorBoundary from '../error-boundary';
import NavBar from './nav-bar/nav-bar';
import CategoryNavRibbon from '../category-nav-ribbon/category-nav-ribbon';
import SimpleHeader from './simple-header/simple-header';
import SimpleHeaderOnSyi from './simple-header/simple-header-syi';
import { MhhNavBar } from './nav-bar/mhh-nav-bar';
import type { ShellState } from '../reducers/common';

const SEARCH_BAR_PAGE_TYPES = ['Homepage', 'ResultsSearch', 'ResultsBrowse'];

const Header = () => {
    const { showSimpleHeaderOnly, showOnMobile, showOnSyiPostFlow, pageType, showSearchBarOnMobile } = useSelector(
        (state: ShellState) => ({
            showSimpleHeaderOnly: state.simpleHeader?.showOnly,
            showOnMobile: state.baseConfig.device.type === 'mobile',
            showOnSyiPostFlow: ['PostAd', 'EditAd'].includes(state.baseConfig.pageType),
            pageType: state.baseConfig.pageType,
            showSearchBarOnMobile: state.searchBar.showSearchBarOnMobile,
        })
    );

    const mhhVariant = useFeatureValue(GrowthBookFeature.MHH, ExperimentVariant.VARIANT_A);
    const isMhhExperiment = mhhVariant === ExperimentVariant.VARIANT_B && showOnMobile;
    const isSearchBarPage = SEARCH_BAR_PAGE_TYPES.includes(pageType);
    const useMhhLayout = isMhhExperiment && (isSearchBarPage || showSearchBarOnMobile);

    const getHeaderContent = () => {
        if (showSimpleHeaderOnly) {
            return <SimpleHeader />;
        }
        if (showOnMobile && showOnSyiPostFlow) {
            return <SimpleHeaderOnSyi />;
        }
        return (
            <>
                <NavBar isMhhExperiment={isMhhExperiment && showOnMobile} />
                <CategoryNavRibbon />
            </>
        );
    };

    return (
        <Fragment>
            <ErrorBoundary>
                <AppDownloadBanner />
                {useMhhLayout && <MhhNavBar />}
                <header className="header">
                    {useMhhLayout ? <CategoryNavRibbon /> : getHeaderContent()}
                </header>
            </ErrorBoundary>
        </Fragment>
    );
};

export default Header;
